<template>
  <div>
    <div :disabled="nodeDetailLoading">
      <Input
        label="forms.vm.name"
        id="name"
        v-model="form.name"
        :state="validateState('name')"
      />

      <div class="button-switch">
        <a
          :class="[
            'button-item',
            { active: selectedImages == 'PlusClouds Images' },
          ]"
          @click="selectImages('PlusClouds Images')"
        >
          PlusClouds Images
        </a>
        <a
          :class="[
            'button-item',
            { active: selectedImages == 'Private Images' },
          ]"
          id="infoPrivateImages"
          :disabled="true"
        >
          Private Images

          <!-- <b-tooltip target="infoPrivateImages"
                   triggers="hover"
                   placement="bottom">
          <div class="tooltipInfo d-flex justify-content-between">
            <i class="fas fa-info" />
            <p>Uyarı mesajı Lorem ipsum dolor sit amet.</p>
          </div>
        </b-tooltip> -->
        </a>
      </div>

      <b-form-group
        :label="$t('servers.templateName')"
        :state="validateState('template')"
      >
        <multiselect
          v-model="form.template"
          :options="templateList"
          track-by="id"
          label="name"
          :loading="loading"
          :allowEmpty="false"
          :show-labels="false"
          :searchable="true"
          :placeholder="$t('servers.templateName')"
          :show-no-results="false"
        />
        <a
          href="javascript:;"
          class="select-from-link"
          @click="openSecondModal"
          >{{ $t('global.selectFromList') }}</a
        >
      </b-form-group>

      <RangeSlider
        label="forms.vm.cpu"
        id="cpu"
        v-model="form.cpu"
        :min="form.min_cpu"
        :max="form.max_cpu"
        unit="Core"
        :state="validateState('cpu')"
      />

      <RangeSlider
        label="forms.vm.ram"
        id="ram"
        v-model="form.ram"
        :min="form.min_ram"
        :max="form.max_ram"
        unit="GB"
        step="0.5"
        :state="validateState('ram')"
      />
    </div>

    <SecondModal
      title="servers.selectTemplate"
      :show="showSecondModal"
      @closeSecondModal="closeSecondModal()"
    >
      <Templates
        @selectedItem="selectedTemplate"
        @closeSecondModal="closeSecondModal()"
      />
    </SecondModal>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'
import JwtService from '@/core/services/jwt.service'
import { validationMixin } from 'vuelidate'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
  name: 'VMCreateAdvanced',
  mixins: [validationMixin],
  props: {
    confirmModal: Boolean,
    dcNode: Array | String,
  },
  data() {
    return {
      nodeDetailLoading: false,
      form: {
        name: '',
        template: '',
        ram: 0,
        min_ram: 0,
        max_ram: 0,
        cpu: 0,
        min_cpu: 0,
        max_cpu: 0,
      },
      templateList: [],
      loading: false,
      selectedImages: 'PlusClouds Images',
      showSecondModal: false,
    }
  },
  validations: {
    form: {
      name: {
        required,
      },
      template: {
        required,
      },
      ram: {
        required,
        minValueValue: minValue(0),
      },
      cpu: {
        required,
        minValueValue: minValue(0),
      },
    },
  },
  created() {
    this.getNodeDetails(this.dcNode.id)
  },
  methods: {
    getNodeDetails(id) {
      this.getNodeDetail(id).then((res) => {
        if (res && res.data) {
          // Böyle bir ayrım varmış başka form için ama Catalog hiç gelmiyormuş, eklenmemiş.
          if (res.data.pricing_model == 'catalog') {
            console.log('pricing model : catalog')
          } else {
            this.getTemplates()
          }

          this.form.min_cpu = res.data.min_cpu_limit
          this.form.max_cpu = res.data.max_cpu_limit
          this.form.min_ram = this.$customFunctions.convertMBtoGBWithHalfPoint(
            res.data.min_ram_limit
          )
          this.form.max_ram = this.$customFunctions.convertMBtoGBWithHalfPoint(
            res.data.max_ram_limit
          )
        }
      })
    },
    getNodeDetail(id) {
      this.nodeDetailLoading = true
      return new Promise((resolve, reject) => {
        ApiService.get(`iaas/datacenter-nodes/${id}`)
          .then(({ data }) => {
            this.nodeDetailLoading = false
            resolve(data)
          })
          .catch((err) => {
            this.nodeDetailLoading = false
            reject(err)
          })
      })
    },
    getTemplates() {
      this.getTemplateList()
        .then((res) => {
          this.setTemplateList(res)
        })
        .catch(() => {
          this.templateList = []
        })
    },
    getTemplateList() {
      this.loading = true
      return new Promise((resolve, reject) => {
        ApiService.get(`iaas/virtual-machines/templates?position=id|desc`)
          .then(({ data }) => {
            resolve(data)
            this.loading = false
          })
          .catch((err) => {
            reject(err)
            this.loading = false
          })
      })
    },
    setTemplateList(res) {
      if (res && res.data && res.data.length > 0) {
        this.templateList = res.data
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    confirm() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        this.$emit('resetDetailForm', false)
        return
      }

      let params = {
        name: this.form.name,
        total_cpu: this.form.cpu,
        total_ram: this.$customFunctions.convertGBtoMB(this.form.ram),
      }

      ApiService.post(
        `iaas/virtual-machines/${this.form.template.id}/clone`,
        params
      )
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
    selectImages(selectedItem) {
      this.selectedImages = selectedItem
    },
    openSecondModal() {
      this.showSecondModal = true
    },
    closeSecondModal() {
      this.showSecondModal = false
    },
    selectedTemplate(item) {
      this.form.template = item
    },
  },
  components: {
    Templates: () =>
      import('@/components/compute/virtualMachines/modals/Templates'),
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.select-from-link {
  font-size: 12px;
  line-height: 18px;
  text-decoration-line: underline;
  color: #00baf2;
}
.button-switch {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  border: 1px solid #eee5ff;
  border-radius: 4px;

  .button-item {
    width: 100%;
    text-align: center;
    padding: 10px 20px;
    font-size: 13px;
    line-height: 19px;
    font-weight: 500;
    color: #6c7293;
    cursor: pointer;

    &.active {
      color: #00baf2;
      background-color: #eee5ff;
    }

    &:hover:not(.active) {
      background-color: rgba(77, 89, 149, 0.06);
      transition: all 0.3s ease;
    }
  }
}
</style>
